import { render, staticRenderFns } from "./wallet-withdrawal.vue?vue&type=template&id=2c00a843"
import script from "./wallet-withdrawal.vue?vue&type=script&lang=js"
export * from "./wallet-withdrawal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports